import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box, Collapse, Stack } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import VSNTypography from "../../shared/VSNTypography";
import OrgExpandRow from "./OrgExpandRow";
import WaiverExpandRow from "./WaiverExpandRow";

const AccordianTable = ({ tableViewPermission }) => {
  const permissions = useSelector(
    (state) => state?.app?.userData?.user_profile?.permissions
  );
  const [openCollapse, setOpenCollapse] = useState(null);

  const toggleReadMore = (id) => {
    setOpenCollapse((prevState) => (prevState === id ? null : id));
  };

  return (
    <>
      {permissions?.[tableViewPermission]?.includes(
        "edit_waiver_preference"
      ) && (
        <Stack
          sx={{
            height: "auto",
            borderBottom: permissions?.[tableViewPermission]?.includes(
              "edit_waiver_preference" && "edit_assessment_preference"
            )
              ? "1px solid #D8DADD"
              : "",
          }}
        >
          <Box px={3} py={2}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <VSNTypography
                variant="h6"
                sx={{ fontWeight: "700", fontSize: "18px" }}
              >
                Waivers Preferences
              </VSNTypography>
              <VSNTypography
                onClick={() => toggleReadMore(2)}
                sx={{
                  "& svg": {
                    verticalAlign: "middle",
                    color: "var(--secondary)",
                  },
                  color: "var(--secondary)",
                  cursor: "pointer",
                }}
              >
                Manage Preferences{" "}
                {openCollapse === 1 ? (
                  <KeyboardArrowUp />
                ) : (
                  <KeyboardArrowDown />
                )}
              </VSNTypography>
            </Stack>
          </Box>

          <Collapse in={openCollapse === 2}>
            <WaiverExpandRow isOpen={openCollapse === 2} />
          </Collapse>
        </Stack>
      )}
      {permissions?.[tableViewPermission]?.includes(
        "edit_assessment_preference"
      ) && (
        <Stack sx={{ height: "auto" }}>
          <Box px={3} py={2}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <VSNTypography
                variant="h6"
                sx={{ fontWeight: "700", fontSize: "18px" }}
              >
                Assessments Preferences
              </VSNTypography>
              <VSNTypography
                onClick={() => toggleReadMore(1)}
                sx={{
                  "& svg": {
                    verticalAlign: "middle",
                    color: "var(--secondary)",
                  },
                  color: "var(--secondary)",
                  cursor: "pointer",
                }}
              >
                Manage Preferences{" "}
                {openCollapse === 1 ? (
                  <KeyboardArrowUp />
                ) : (
                  <KeyboardArrowDown />
                )}
              </VSNTypography>
            </Stack>
          </Box>

          <Collapse in={openCollapse === 1}>
            <OrgExpandRow isOpen={openCollapse === 1} />
          </Collapse>
        </Stack>
      )}
    </>
  );
};

export default AccordianTable;
